export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "extraction_failed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une erreur a eu lieu lors de l'extraction. Veuillez remplir les coûts manuellement."])},
        "extraction_not_found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucun coût n'a pu être détecté automatiquement. Veuillez les remplir manuellement."])}
      },
      "en": {
        "extraction_failed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An error occurred during extraction. Please fill in the costs manually."])},
        "extraction_not_found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No cost could be detected automatically. Please fill them in manually."])}
      }
    }
  })
}
